import React, { useRef, useEffect } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import { COLORS } from 'styles'

interface LevelCardProperties {
  title: string
  totalValue: number | undefined
  totalValuePrevious: number | undefined
  birthdayValue: number | undefined
  birthdayValuePrevious: number | undefined
}

const formatValue = (value: number | undefined) => {
  if (!value && value !== 0) return '0'
  return value.toString()
}

const LevelCard: React.FC<LevelCardProperties> = ({
  title,
  totalValue,
  totalValuePrevious,
  birthdayValue,
  birthdayValuePrevious,
}) => {
  const totalRef = useRef<HTMLDivElement>(null)
  const birthdayRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const adjustFontSize = (ref: React.RefObject<HTMLDivElement>) => {
      if (ref.current) {
        const container = ref.current
        const text = container.textContent || ''
        const containerWidth = container.offsetWidth
        const fontSize = Math.min(32, containerWidth / (text.length * 0.6))
        container.style.fontSize = `${fontSize}px`
      }
    }

    adjustFontSize(totalRef)
    adjustFontSize(birthdayRef)
    window.addEventListener('resize', () => {
      adjustFontSize(totalRef)
      adjustFontSize(birthdayRef)
    })
    return () => {
      window.removeEventListener('resize', () => {
        adjustFontSize(totalRef)
        adjustFontSize(birthdayRef)
      })
    }
  }, [totalValue, birthdayValue])

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" component="h3" align="center" style={{ marginBottom: 16, fontWeight: 'bold', color: COLORS.FONT }}>
          {title}
        </Typography>
        
        <Box style={{ marginBottom: 16 }}>
          <Typography
            variant="h4"
            component="div"
            align="center"
            ref={totalRef}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '100%',
              marginBottom: 4,
            }}
          >
            {formatValue(totalValue)}
          </Typography>
          <Typography color="textSecondary" align="center" variant="body2">
            Total Usuarios
          </Typography>
        </Box>

        <Box>
          <Typography
            variant="h4"
            component="div"
            align="center"
            ref={birthdayRef}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '100%',
              marginBottom: 4,
            }}
          >
            {formatValue(birthdayValue)}
          </Typography>
          <Typography color="textSecondary" align="center" variant="body2">
            Cumplea{'\u00F1'}os
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

export { LevelCard }

